<template>
  <v-card class="pa-4" flat>
    <div class="d-flex justify-end">
      <v-btn
        class="btn-delete rounded-lg"
        @click="
          goback = false;
          $emit('refresh');
        "
        ><v-icon small>mdi-arrow-right</v-icon>بازگشت</v-btn
      >
    </div>
    <v-row class="mt-5" no-gutters>
      <v-flex class="p-3" lg4 md4 sm12 xl4 xs12>
        <v-text-field
          ref="title"
          v-model="title"
          :error-messages="errors.title"
          :rules="rules.title"
          dense
          label="عنوان"
          outlined
          return-object
        />
      </v-flex>
      <v-flex class="p-3" lg4 md4 sm12 xl4 xs12>
        <v-select
          v-model="type"
          :error-messages="errors.type"
          :items="types"
          :menu-props="{ offsetY: true }"
          clearable
          dense
          item-text="name"
          item-value="value"
          label=" نوع متن - ثابت یا پترن"
          outlined
        />
      </v-flex>
      <v-flex class="p-3" lg4 md4 sm12 xl4 xs12>
        <v-autocomplete
          v-model="phone_id"
          :error-messages="errors.phone_id"
          :items="phones"
          :loading="phones.length <= 0"
          clearable
          dense
          item-text="numbers"
          item-value="id"
          label="شماره ها"
          outlined
          @keydown="isNumericKey"
        >
          <template slot="item" slot-scope="{ item }">
            <div style="display: flex; flex-direction: column">
              <span>
                {{
                  item.subnumber.phone === "12345"
                    ? "خبری "
                    : item.subnumber.phone
                }}{{ item.numbers }} {{ item.category.title }}
                {{
                  item.state === "pending"
                    ? "(منتظر فعالسازی) "
                    : item.state === "deactivate"
                    ? "(غیر فعال) "
                    : ""
                }}
              </span>

              <span style="font-size: 0.85rem; color: gray">
                {{ item.user?.name || "" }} {{ item.user?.lastName || "" }}
              </span>
            </div>
          </template>
          <template slot="no-data" class="rounded">
            <span class="mx-2 text-dark-50">شما هیچ شماره ای ندارید!</span>
          </template>
          <template slot="selection" slot-scope="{ item }">
            {{
              item.subnumber.phone === "12345" ? "خبری " : item.subnumber.phone
            }}-{{ item.numbers }}
          </template>
        </v-autocomplete>
      </v-flex>
    </v-row>
    <v-row no-gutters>
      <v-flex class="px-3">
        <suggest-text
          v-model="content"
          :label="$t('FORMS.Text')"
          :rules="rules.text"
          :title-input="$refs.title"
        />
      </v-flex>
    </v-row>
    <v-row no-gutters>
      <v-flex class="p-3">
        <v-textarea
          v-model="desc"
          :error-messages="errors.desc"
          dense
          label="توضیحات"
          outlined
        />
      </v-flex>
    </v-row>

    <v-card-actions class="d-flex justify-space-between pa-0">
      <v-btn :loading="loading" class="btn-add-with-text" @click="setPhone">
        <v-icon class="me-2">mdi-plus</v-icon>
        ثبت پترن/ثابت
      </v-btn>
      <v-btn
        class="btn-delete rounded-lg"
        @click="
          goback = false;
          $emit('refresh');
        "
        ><v-icon small>mdi-close</v-icon>انصراف</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import userPicker from "../../../core/plugins/TitleRibbon/pages/pickers/userPicker.vue";
import SuggestText from "@/view/components/SuggestBox/suggestInput";
import { SmsAxios } from "@/main";

export default {
  name: "createPattern",
  props: { value: Boolean },

  directives: {
    focus(el) {
      el.focus();
    },
  },
  components: { SuggestText, userPicker },
  data() {
    return {
      phones: [],
      phone_id: null,
      loading: false,
      title: "",
      content: "\nلغو11",
      desc: "",
      type: null,
      types: [
        { name: "پترن", value: "pattern" },
        { name: "ثابت", value: "normal" },
      ],
      rules: {
        title: [
          // v => " عنوان را وارد کنید",
          // val => !!val || 'تعداد ارقام شماره را وارد کنید',
          // v => v.length > 3 || "حداقل باید سه کارکتر باشد"
        ],
        content: [
          // v => "متن را وارد کنید.",
          // val => !!val || 'متن را وارد کنید.',
          // v => v.length > 3 || "حداقل سه کارکتر باید باشد."
        ],
        type: [
          // v =>  " تاریخ انقضا باید عدد باشد.",
          // val => !!val || 'تاریخ انقضا را وارد کنید.',
          // v => v > 0 || "عدد مورد نظر باید عددی بزرگتر از 1 باشد."
        ],
        text: [
          (n) => !!n || this.$t("ERRORS.EmptyText"),
          (n) => n.includes("لغو11") || 'بایستی شامل عبارت "لغو11" باشد',
        ],
      },
      errors: [],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$route.meta.title }]);
    this.getUserPhone();
  },
  computed: {
    goback: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getKhadamatiColor(khadamati) {
      const colors = {
        1: "#ff5722",
        2: "#2196f3",
        3: "#4caf50",
        4: "#9c27b0",
        5: "#ff9800",
      };
      return colors[khadamati] || "#000";
    },
    getColor(item) {
      let color = "#000000";
      if (item.user_id === null) {
        color = "#1565c0";
      }
      if (
        item.user_id === null &&
        (item.subnumber.phone === "5004" || item.subnumber.phone === "5002")
      ) {
        color = "#2e7d32";
      }

      if (item.user_id !== 88 && item.user_id !== null) {
        color = "#6a1b9a";
      }
      if (item.subnumber.phone === "12345") {
        color = "#c62828";
      }

      if (item.category?.title === "سفارشی" && item.user_id !== 88) {
        color = "#ef6c00";
      }

      if (item.user_id === 88) {
        color = "#424242";
      }

      return color;
    },
    getUserPhone() {
      SmsAxios.get("phone").then(({ data }) => {
        this.phones = data.data;
      });
    },

    setPhone() {
      this.loading = true;
      SmsAxios.post("text/create", {
        title: this.title,
        content: this.content,
        type: this.type,
        desc: this.desc,
        phone_id: this.phone_id,
      })
        .then(({ data }) => {
          this.$toast.success(data.message);
          // this.$router.push({ name: "text.user.list" });
          // this.$emit("fetch");
          this.$toast.success("پترن با موفقیت ثبت شد");
          this.$emit("refresh");
          this.goback = false;
          this.errors = [];
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
